module.exports = __webpack_public_path__ + "static/media/screen5.018c5f75.png";